"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.avatar.id': 'Avatar ID',
};
